import type { VideoCompanionPersonProfile } from "../../config/videoCompanionDemo";
import { assetUrl } from "../../utils/assetUrl";
import "./ActorIdentityCard.css";

interface ActorIdentityCardProps {
  fallbackImageSrc: string;
  person: VideoCompanionPersonProfile;
  selected: boolean;
  onSelect: () => void;
}

export function ActorIdentityCard({
  fallbackImageSrc,
  person,
  selected,
  onSelect
}: ActorIdentityCardProps) {
  const avatarSrc = person.avatarImageSrc ?? person.imageSrc ?? fallbackImageSrc;

  return (
    <button
      className="actor-identity-card"
      data-selected={selected ? "true" : "false"}
      type="button"
      role="tab"
      aria-selected={selected}
      onClick={onSelect}
    >
      <span className="actor-identity-card__portrait" aria-hidden="true">
        <img
          src={assetUrl(avatarSrc)}
          alt=""
          draggable={false}
          style={{ objectPosition: person.avatarPosition ?? "center 24%" }}
        />
      </span>
      <span className="actor-identity-card__name">{person.tabLabel ?? person.name}</span>
    </button>
  );
}
